const DK = {
  listedPublicCompany: [
    "aktieselskab (A/S)"
  ],
  nonProfit: [
    "erhvervsdrivende fond"
  ],
  privateCompany: [
    "iværksætterselskab (IVS)",
    "anpartsselskab (ApS)",
    "selskab med begrænset ansvar (SMBA)"
  ]
};
export {
  DK as default
};
